import React, { useEffect, useRef } from "react";

// SASS
import "./Part12.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import stickyNoteImg from "../../assets/img/sticky-note.png";
import sparkle1Img from "../../assets/img/yellow-sparkle.svg";
import sparkle2Img from "../../assets/img/Sparkles.png";

// FUNCTION EXPORT
export default function Part12({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in text and sparkles" },
    { stepNumber: "2", height: null, description: "spacer" },
    { stepNumber: "3", height: null, description: "spacer" },
  ];

  // REFS
  const stickyTextEl = useRef(null);
  const sparkle1El = useRef(null);
  const sparkle2El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(stickyTextEl.current, direction);
            animate.fadeInOnEnter(sparkle1El.current, direction);
            animate.fadeInOnEnter(sparkle2El.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(stickyTextEl.current, direction);
            animate.fadeOutOnExit(sparkle1El.current, direction);
            animate.fadeOutOnExit(sparkle2El.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div
        className="sticky-container"
        style={{ height: "auto", top: "50%", marginTop: "-220px" }}
      >
        {/* STICKY */}
        <div className="part12">
          <div className="sticky-note">
            <img src={stickyNoteImg} alt="" className="img-fluid" />
            <div className="sticky-note__text shimmer" ref={stickyTextEl}>
              When you disinfect a surface, you want to do it correctly to keep
              patients safe!
            </div>
          </div>
          <div
            className="sparkle sparkle-1 pulse delay-random-1"
            ref={sparkle1El}
          >
            <img src={sparkle1Img} alt="" className="img-fluid" />
          </div>
          <div
            className="sparkle sparkle-2 pulse delay-random-2"
            ref={sparkle2El}
          >
            <img src={sparkle2Img} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
